module.exports = __webpack_public_path__ + "static/media/nip-pending.26158ca8.svg";